import { getSupportData } from "../services/services"
import * as language from '../constants/languages'
import Addressicon from '../assets/svg/aboutus/addressicon.svg'
import Email from '../assets/svg/aboutus/email.svg'
import Phone from '../assets/svg/aboutus/phone.svg'
import Facebook from '../assets/svg/facebook.svg'
import InstaGram from '../assets/svg/instagram.svg'
import LinkedIn from '../assets/svg/linkedin.svg'
import YouTube from '../assets/svg/youtube.svg'
import CompanyLogo from "../assets/header_logo.png";
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import '../styles/FooterComponent.css'
import { ReactSVG } from "react-svg"

export default function FooterComponent() {
    const navigate = useNavigate()
    const location = useLocation()
    const [number, setnumber] = useState([])
    const [email, setemail] = useState([])
    const [contactus, setcontactus] = useState([])
    const [contactData, setcontactData] = useState()
    const [logo, setlogo] = useState()

    useEffect(() => {
        getSupportInfoData()
        getCompanyInfo()
    }, [])

    async function getCompanyInfo() {
        const value = localStorage.getItem('companyInfo')
        if (value) {
            let companyInfo = JSON.parse(value);
            const Logo = companyInfo.logo !== "" ? companyInfo.logo : CompanyLogo;
            setlogo(Logo)
        }
    }

    async function getSupportInfoData() {
        await getSupportData(language.companyidValue).then((supportData) => {
            if (supportData.status === 'success') {
                if (supportData.data.contactNos != null) {
                    if (supportData.data.contactNos.length > 1) {
                        setnumber(supportData.data.contactNos.split(','))
                    } else {
                        setnumber(supportData.data.contactNos)
                    }
                } else {
                    setnumber([])
                }
                if (supportData.data.contactEmail != null) {
                    if (supportData.data.contactEmail.length > 1) {
                        setemail(supportData.data.contactEmail.split(','))
                    } else {
                        setemail(supportData.data.contactEmail)
                    }
                } else {
                    setemail([])
                }
                if (supportData.data.contactus != null) {
                    if (supportData.data.contactus.length > 1) {
                        setcontactus(supportData.data.contactus.split(','))
                    } else {
                        setcontactus(supportData.data.contactus)
                    }
                } else {
                    setcontactus([])
                }
                setcontactData(supportData)
            }
        })
    }

    const isNoMarginFooter = ['/sharecatalogue', '/cart'].includes((location.pathname || '').toLowerCase());

    return (
        <footer className={`footer-wrapper ${isNoMarginFooter ? 'footer-no-margin footer-share-catalogue' : ''}`}>
            <div className="footer-content-container">
                {/* ── Col 1: Brand Logo ── */}
                <div className="footer-col-brand" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                    {logo && (
                        <img
                            src={logo}
                            alt="Company Logo"
                            className="footer-brand-logo"
                            style={{ cursor: 'pointer' }}
                        />
                    )}
                </div>

                {/* ── Col 2: Quick Links ── */}
                <div className="footer-col-nav">
                    <h4 className="footer-heading">Quick Links</h4>
                    <div className="footer-links-list">
                        <span
                            className={`footer-nav-link ${location.pathname === '/' ? 'active' : ''}`}
                            onClick={() => navigate('/')}
                        >
                            Home
                        </span>
                        <span
                            className={`footer-nav-link ${location.pathname === '/Categories' ? 'active' : ''}`}
                            onClick={() => navigate('/Categories')}
                        >
                            Categories
                        </span>
                        <span
                            className={`footer-nav-link ${location.pathname === '/Offers' ? 'active' : ''}`}
                            onClick={() => navigate('/Offers')}
                        >
                            Offers
                        </span>
                        <span
                            className={`footer-nav-link ${location.pathname === '/About' ? 'active' : ''}`}
                            onClick={() => navigate('/About')}
                        >
                            About Us
                        </span>
                    </div>
                </div>

                {/* ── Col 3: Contact Info ── */}
                <div className="footer-col-contact">
                    <h4 className="footer-heading">Contact Info</h4>
                    <div className="footer-contact-list">
                        {contactus?.length > 0 && (
                            <div className="footer-contact-row">
                                <div className="footer-contact-icon">
                                    <img src={Addressicon} alt="Address" />
                                </div>
                                <div className="footer-contact-details">
                                    <span className="footer-contact-label">Address</span>
                                    <div
                                        className="footer-contact-value"
                                        dangerouslySetInnerHTML={{ __html: contactus }}
                                    />
                                </div>
                            </div>
                        )}

                        {number?.length > 0 && (
                            <div className="footer-contact-row">
                                <div className="footer-contact-icon">
                                    <img src={Phone} alt="Phone" />
                                </div>
                                <div className="footer-contact-details">
                                    <span className="footer-contact-label">Phone</span>
                                    {Array.isArray(number) ? (
                                        number.map((num, index) => (
                                            <a
                                                key={index}
                                                href={`tel:${num.trim()}`}
                                                className="footer-contact-value"
                                            >
                                                {num.trim()}
                                            </a>
                                        ))
                                    ) : (
                                        <a href={`tel:${number}`} className="footer-contact-value">
                                            {number}
                                        </a>
                                    )}
                                </div>
                            </div>
                        )}

                        {email?.length > 0 && (
                            <div className="footer-contact-row">
                                <div className="footer-contact-icon">
                                    <img src={Email} alt="Email" />
                                </div>
                                <div className="footer-contact-details">
                                    <span className="footer-contact-label">Email</span>
                                    {Array.isArray(email) ? (
                                        email.map((em, index) => (
                                            <a
                                                key={index}
                                                href={`mailto:${em.trim()}`}
                                                className="footer-contact-value"
                                            >
                                                {em.trim()}
                                            </a>
                                        ))
                                    ) : (
                                        <a href={`mailto:${email}`} className="footer-contact-value">
                                            {email}
                                        </a>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ── Col 4: Follow Us ── */}
                <div className="footer-col-social">
                    <h4 className="footer-heading">Follow Us</h4>
                    <div className="footer-social-list">
                        {contactData?.data?.facebook && (
                            <ReactSVG
                                src={Facebook}
                                className="footer-social-media"
                                onClick={() => window.open(contactData.data.facebook, '_blank')}
                            />
                        )}
                        {contactData?.data?.instagram && (
                            <ReactSVG
                                src={InstaGram}
                                className="footer-social-media"
                                onClick={() => window.open(contactData.data.instagram, '_blank')}
                            />
                        )}
                        {contactData?.data?.linkedin && (
                            <ReactSVG
                                src={LinkedIn}
                                className="footer-social-media"
                                onClick={() => window.open(contactData.data.linkedin, '_blank')}
                            />
                        )}
                        {contactData?.data?.youtube && (
                            <ReactSVG
                                src={YouTube}
                                className="footer-social-media"
                                onClick={() => window.open(contactData.data.youtube, '_blank')}
                            />
                        )}
                    </div>
                </div>
            </div>

            {/* ── Bottom Bar ── */}
            <div className="footer-bottom-bar">
                <p className="footer-copyright-text">
                    Copyright {new Date().getFullYear()} © Xenia All Rights reserved
                </p>
            </div>
        </footer>
    )
}